import React, { useEffect, useState } from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Divider,
    Grid2,
    List,
    ListItem,
    ListItemText,
    Snackbar,
    Stack,
    Step,
    StepConnector,
    stepConnectorClasses,
    StepLabel,
    Stepper,
    styled,
    Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../StudentBreadcrumb/Breadcrumb";
import SideBar from "../../Dashboard/StudentDashboard/Sidebar/SideBar";
import {
    useGetClassMasterListMutation,
    useGetCourseMasterMutation,
    useGetUserInfoMutation,
} from "../../../apiSlice";
import { API_courseURL } from "../../../config";
import { useParentalInfoCheck } from "../../context/ParentalInfoCheck";
import MuiAlert from "@mui/material/Alert";

const CourseList = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState();
    const [courseData, setCourseData] = useState([]);
    const { isParentInfoPresent, snackbarOpen, setSnackbarOpen } =
        useParentalInfoCheck();

    function setCourseInternalData(course) {
        sessionStorage.setItem("courseData", JSON.stringify(course));
        navigate("/StudentDashboard/Course");
    }
    const [studentDataAPI] = useGetUserInfoMutation();
    const [studentCourseMasterAPI] = useGetCourseMasterMutation();
    const [classMasterList] = useGetClassMasterListMutation();

    const classMasterListData = [
        {
            classId: 32,
            className: "Class IX CBSE Odisha",
            classDescription: "LMS for Odisha Board\n",
            createdAt: "2025-07-11T19:09:42.833",
        },
        {
            classId: 31,
            className: "Class VIII Odisha",
            classDescription: "LMS for Odisha Board",
            createdAt: "2025-07-11T19:09:42.833",
        },
        {
            classId: 30,
            className: "Class VII Odisha",
            classDescription: "LMS for Odisha board",
            createdAt: "2025-07-11T19:09:42.833",
        },
        {
            classId: 29,
            className: "Class VI Odissa",
            classDescription: "LMS For ODissa Board",
            createdAt: "2025-07-11T19:09:42.833",
        },
        {
            classId: 28,
            className: "VIII",
            classDescription: "VIII",
            createdAt: "2025-07-11T19:09:42.833",
        },
        {
            classId: 27,
            className: "Class 8 Trial Class",
            classDescription: "Trial Class for Class 8",
            createdAt: "2025-07-11T19:09:42.833",
        },
        {
            classId: 26,
            className: "Class 7 Trial Class",
            classDescription: "Trial Class class 7",
            createdAt: "2025-07-11T19:09:42.833",
        },
        {
            classId: 25,
            className: "Class 6 Trial Class ",
            classDescription: "Trial Class for 6",
            createdAt: "2025-07-11T19:09:42.833",
        },
        {
            classId: 21,
            className: "VI",
            classDescription: "This is for class 6",
            createdAt: "2025-07-11T19:09:42.833",
        },
        {
            classId: 20,
            className: "Trial Class 8",
            classDescription: "Trial class for 8",
            createdAt: "2025-07-11T19:09:42.833",
        },
        {
            classId: 19,
            className: "9th CBSE",
            classDescription: "This is 9th CBSE",
            createdAt: "2025-07-11T19:09:42.833",
        },
        {
            classId: 18,
            className: "10th CBSE",
            classDescription: "This is for 10th CBSE",
            createdAt: "2025-07-11T19:09:42.833",
        },
        {
            classId: 17,
            className: "8th",
            classDescription: "This is for Class 8",
            createdAt: "2025-07-11T19:09:42.833",
        },
        {
            classId: 16,
            className: "10th ICSE",
            classDescription: "10th",
            createdAt: "2025-07-11T19:09:42.833",
        },
        {
            classId: 15,
            className: "9th ICSE",
            classDescription: "9th",
            createdAt: "2025-07-11T19:09:42.833",
        },
        {
            classId: 13,
            className: "7th",
            classDescription: "Class 7",
            createdAt: "2025-07-11T19:09:42.833",
        },
        {
            classId: 12,
            className: "Class VI Odisha",
            classDescription: "LMS For Odisha Board",
            createdAt: "2025-07-11T19:09:42.833",
        },
    ].map((cls) => ({ classId: cls.classId, className: cls.className }));

    /**
     * Setting the "List of Classes" for further use
     */
    sessionStorage.setItem("listOfClass", JSON.stringify(classMasterListData))

    // useEffect(() => {
    //     console.log("classMasterListData ======== ", classMasterListData);
    // }, [classMasterListData])

    useEffect(() => {
        const fetchMasters = async () => {
            if (loading) {
                try {
                    setLoading(true);

                    const courseMaster = await studentCourseMasterAPI();
                    setCourseData(courseMaster.data);

                    const studentData = await studentDataAPI();
                    setUserData(studentData.data[0]);

                    const classMasterListData = await classMasterList();

                    console.log(
                        "classMasterListData ========= ",
                        classMasterListData
                    );
                } catch (error) {
                    console.error("Error fetching data:", error);
                } finally {
                    setLoading(false);
                }
            }
        };
        fetchMasters();
    }, [loading]);

    return (
        <>
            <SideBar />
            <Box
                sx={{
                    flexGrow: 1,
                    position: "relative",
                    width: "calc(100vw - 80px)",
                    padding: "20px",
                    height: "100vh",
                    overflowY: "auto",
                    left: "80px",
                    backgroundColor: "#F8F9FD",
                }}
            >
                <Breadcrumb />
                <Grid2>
                    <Box bgcolor="white" borderRadius="12px" padding="20px">
                        <Typography variant="h5" marginBottom="10px">
                            Course List
                        </Typography>
                        <Divider />
                        <Stack spacing={2} marginTop="20px">
                            <Grid2 container spacing={2}>
                                {Object.keys(courseData).length === 0 ||
                                courseData === null ? (
                                    <Typography
                                        variant="subtitle1"
                                        color="secondary"
                                    >
                                        No Course Data Available
                                    </Typography>
                                ) : courseData?.length > 0 ? (
                                    courseData
                                        .filter(
                                            (e) =>
                                                e.subject ===
                                                userData?.className
                                        )
                                        .map((course, index) => (
                                            <Grid2
                                                sx={{ cursor: "pointer" }}
                                                size={8}
                                                container
                                                direction="row"
                                                padding="10px"
                                                border="1px solid #F3F0EC"
                                                borderRadius="6px"
                                                height="195px"
                                                key={index}
                                                onClick={() =>
                                                    setCourseInternalData(
                                                        course
                                                    )
                                                }
                                            >
                                                <Grid2 size={3}>
                                                    <img
                                                        style={{
                                                            height: "100%",
                                                            width: "100%",
                                                            maxHeight: "173px",
                                                            maxWidth: "250px",
                                                            objectFit: "cover",
                                                            borderRadius: "6px",
                                                            objectPosition:
                                                                "top",
                                                        }}
                                                        src={
                                                            API_courseURL +
                                                            course.courseThumbnailImagepath
                                                        }
                                                        alt={course.courseName}
                                                    />
                                                </Grid2>
                                                <Grid2 size={9}>
                                                    <Typography variant="h5">
                                                        {course.courseName}
                                                    </Typography>
                                                    <Typography variant="caption">
                                                        {course.courseCode}
                                                    </Typography>
                                                </Grid2>
                                            </Grid2>
                                        ))
                                ) : (
                                    "null"
                                )}
                            </Grid2>
                            {/* {quizData.studentQuizMaster?.length > 0 && quizData.studentQuizMaster.map((quiz, index) => (
                <Stack direction='row' border='1px solid #F3F0EC' padding='10px' borderRadius='6px' justifyContent='space-between' alignItems='center' key={index}>
                  <Stack direction='row' spacing={2}>
                    <Box>
                      <img style={{ height: '50px', width: '60px' }} />
                    </Box>
                    <Box>
                      <Typography>{quiz.quizTittle}</Typography>
                      <Typography>{quiz.quizDescription}</Typography>
                    </Box>
                  </Stack>
                  <Box>
                    <Button variant='contained' onClick={() => { setQuizData(prev => ({ ...prev, studentQuizData: quiz })); navigate('/StudentDashboard/Quiz/QuizContent') }}>Take Quiz</Button>
                  </Box>

                </Stack>
              ))} */}
                        </Stack>
                    </Box>
                </Grid2>
            </Box>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={() => setSnackbarOpen(false)}
            >
                <MuiAlert
                    onClose={() => setSnackbarOpen(false)}
                    severity="error"
                    sx={{ width: "100%" }}
                >
                    Add your Parent Information
                </MuiAlert>
            </Snackbar>
        </>
    );
};

export default CourseList;
